import { isEmpty } from 'lodash-es';
import { shallow } from 'zustand/shallow';
import { IS_USE_PLEX_API } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useGamesStore } from '../../store';
import { selectCategories } from '../helpers';

export const useLobbyCategories = (
  feedName: string,
  casinoType: CasinoTypeUnion
) => {
  return useGamesStore((store) => {
    const { categories: feedCategories } = store.feeds[feedName] || {};
    const plexCategories = store.lobbies[casinoType]?.categories;
    if (IS_USE_PLEX_API) {
      return isEmpty(plexCategories) ? [] : selectCategories(plexCategories);
    }
    return isEmpty(feedCategories) ? [] : selectCategories(feedCategories);
  }, shallow);
};
